// extracted by mini-css-extract-plugin
module.exports = {"PrintShare":"PrintShare_PrintShare__LiGLM"};